import _ from 'lodash';
import { GetStaticPaths, GetStaticProps } from 'next';
import {
  ProductsSeriesPage,
  fetchProductsSeriesData,
  fetchProductsSeriesListing,
} from 'src/modules/products';
import fs from 'fs';
import filterPathsListWithOutputChannel from 'src/utils/filterPathsListWithOutputChannel';

export const getStaticPaths: GetStaticPaths = async () => {
  const data = await fetchProductsSeriesListing();
  const productSeries = data?.productSeries || [];

  const getPaths = (lang: 'en' | 'de') =>
    _.chain(productSeries)
      .filter((p) => p.slug && !_.isEmpty(p.products))
      .map(({ slug }) => ({
        params: { slug },
        locale: lang,
      }))
      .value();

  const paths = [...getPaths('en'), ...getPaths('de')];

  const pathsList = filterPathsListWithOutputChannel(
    _.map(paths, (p) => `${p.locale}/products/family/${p.params.slug}`)
  );

  fs.writeFileSync(
    './public/data/paths/products_family_slug.json',
    JSON.stringify(pathsList, null, 2)
  );

  return { paths: [], fallback: true };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const slug = params?.slug as string;

  const data = await fetchProductsSeriesData(slug);

  return { props: { page: data?.productSeries?.[0] || null } };
};

export default ProductsSeriesPage;
